module.exports = __webpack_public_path__ + "static/media/location7.223d8a36.webp";